import { ResizeHandle } from 'react-resizable'

export const resizeHandleToCursor = (handle: ResizeHandle | null): string => {
  if (handle === 'n' || handle === 's') {
    return 'ns-resize'
  } else if (handle === 'e' || handle === 'w') {
    return 'ew-resize'
  } else if (handle === 'nw' || handle === 'se') {
    return 'nwse-resize'
  } else if (handle === 'ne' || handle === 'sw') {
    return 'nesw-resize'
  } else {
    return 'inherit'
  }
}
